/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA
 */
import {parseJwtPayload} from '@/core/accessToken/accessToken';

/**
 * Returns authorized user
 * @returns {Promise<User|null>}
 */
export const getUser = () => {
    const jwtToken = parseJwtPayload(sessionStorage.getItem('accessToken'));
    const { hierarchy, tenant_id, email } = jwtToken;
    let { roles } = jwtToken;
    let ltiRoles = jwtToken["https://purl.imsglobal.org/spec/lti/claim/roles"];
    ltiRoles = ltiRoles.map(role => role.split('#').pop());
    roles = (roles || []).concat(ltiRoles);
    return {
        userId: jwtToken.ltiClaims.sub,
        name: jwtToken.name,
        roles: roles,
        email: email,
        tenantId: tenant_id,
        hierarchy
    };
};